import {Component, OnInit} from '@angular/core';
import {SurveyHeaderService} from '../../../provider/survey-header.service';
import {Router} from '@angular/router';

@Component({
  selector: 'cs-survey-list',
  templateUrl: './survey-list.component.html',
  styleUrls: ['./survey-list.component.scss']
})
export class SurveyListComponent implements OnInit {
  filteredData = false;
  loading = false;

  constructor(public surveyHeader: SurveyHeaderService,
              public router: Router) {
  }

  ngOnInit() {
  }

  goProfile(id: any) {
    this.router.navigateByUrl('/activity/profile/' + id);
  }

  onPointClick(e, interval) {
    this.filteredData = true;
    this.surveyHeader.filterData(interval, e.target.originalArgument);
  }

  onButtonClick() {
    this.filteredData = false;
    this.surveyHeader.filterData('all');
  }

}
